import './otpComponent.scss'
import React, {useState} from 'react';
import OtpInput from 'react-otp-input';

interface OtpComponentProps {
    numInputs: number,
    onUpdate?: Function,
    isInputNum?: boolean,
    hasErrored?: boolean,
    isDisabled?: boolean,
    separator?: string,
    margin?: string
}

const OtpComponent = (props: OtpComponentProps) => {
        const {numInputs, onUpdate, isInputNum, hasErrored, isDisabled, separator} = props;
        let {margin} = props;
        const [value, setValue] = useState<any>('');

        if (!margin) margin = "0 30px 0 1px";

        return (
            <div className="otp-component">
                <OtpInput
                    hasErrored={hasErrored}
                    isInputNum={isInputNum}
                    isDisabled={isDisabled}
                    onChange={(otp: any) => {
                        setValue(otp)
                        if (onUpdate && otp.length === numInputs) {
                            onUpdate(otp);
                        }
                    }}
                    numInputs={numInputs}
                    value={value}
                    inputStyle={{
                        width: "3rem",
                        height: "3rem",
                        margin: margin,
                        fontSize: "2rem",
                        borderRadius: 4,
                        border: "1px solid rgba(0,0,0,0.3)"
                    }}
                    separator={separator && <span>{separator}</span>}
                />
            </div>
        );
    }

;

export default OtpComponent;